@if (searchService.search_loading) {
  <app-loading-screen icon="ico-fast-track ico-material" [animated]="animated">
    <span title i18n="@@fastTrackresultsloading_title">Just loading your search results</span>
    <div msgOne>
      <span i18n="@@fastTrackresultsloading_msgOne">Airport Fast Track For</span>
      {{ searchParams.locationCode.destination }} ({{
        searchParams.locationCode.gateway.toUpperCase()
      }}) ({{ searchParams.selectedTerminal }})
    </div>
    <span msgTwo i18n="@@fastTrackresultsloading_msgTwo">Checking for availability</span>
  </app-loading-screen>
}
